import { ref } from "vue";
import { Snackbar as _Snackbar } from "@/shared/model/snackbar";

const snackbars = ref<_Snackbar[]>([]);

export default function useSazkaSnackbar() {
    const createSnackbar = (options: _Snackbar) => {
        const existingIndex = snackbars.value.findIndex((snackbar) => snackbar.message === options.message);

        if (existingIndex !== -1) {
            const existing = snackbars.value[existingIndex];

            snackbars.value[existingIndex] = {
                ...existing,
                duration: options.duration || existing.duration,
            };
        } else {
            snackbars.value.push(options);
        }
    };

    const removeSnackbar = (options: _Snackbar) => {
        const index = snackbars.value.findIndex((snackbar) => snackbar.message === options.message);

        if (index !== -1) {
            snackbars.value.splice(index, 1);
        }
    };

    return {
        snackbars,
        createSnackbar,
        removeSnackbar,
    };
}
